import { debounce } from 'lodash-es';
import { MethodFactory, RootLogger } from 'loglevel';

type Options = {
  storeKey: string,
  maxLogStackSize: number,
  storage: Storage,
};

export function logToStorage(rootLogger: RootLogger, options: Partial<Options> = {}) {

  // this constant was moved _inside_ this function on update to next@12.1.0,
  // because it now got _interpreted_ on build, where window.localStorage was not available.
  const defaultOptions: Options = {
    storeKey: 'tbit-log',
    maxLogStackSize: 100,
    storage: window.localStorage,
  };

  const { storeKey, maxLogStackSize, storage } = { ...defaultOptions, ...options };
  let logStack: string[] = JSON.parse(storage?.getItem(storeKey) || '[]');

  const originalFactory: MethodFactory = rootLogger.methodFactory;

  // replace original method factory by modified factory (i.e middleware that writes to local storage)
  rootLogger.methodFactory = function (methodName, logLevel, loggerName) {
    const rawMethod = originalFactory(methodName, logLevel, loggerName);

    return function (...args) {
      // calls the original logging method every time
      rawMethod(...args);

      const message = new Date(Date.now()).toISOString() + ' ' + methodName.toUpperCase() + ' ' + args.join(' ');

      logStack = [
        ...logStack.slice(-maxLogStackSize + 1),
        message
      ];

      storeLogStack();
    };
  };

  rootLogger.setLevel(rootLogger.getLevel()); // sets the level to start logging into local storage, @see https://github.com/pimterry/loglevel#writing-plugins

  const storeLogStack = debounce(() => {
    if (!logStack.length) return;
    storage.setItem(storeKey, JSON.stringify(logStack));
  }, 250);
};
